import { type ComponentProps } from 'react';
import { styled } from 'styled-components';
import { getTokenIcon } from '../../utils/racing-game/helpers.ts';
import type { StableName } from '../../utils/racing-game/horses.ts';
import { HorseName } from '../../utils/racing-game/consts.ts';

export type GameItemIconProps = {
  name: HorseName | StableName;
} & Omit<ComponentProps<typeof Item>, 'src' | 'alt'>;

const GameItemIcon = ({ name, ...props }: GameItemIconProps) => {
  const src = getTokenIcon(name);
  return <Item src={src} alt={name} {...props} />;
};

const Item = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;

  ${({ theme }) => theme.getUpMedia('md')} {
    width: ${({ theme }) => theme.responsive(32)};
    height: ${({ theme }) => theme.responsive(32)};
  }
`;

export { GameItemIcon };
